import {
  MarkupStyle,
  Product,
  Uom,
} from "@towersystems/roam-common/lib/generated-types";
import { ProductFormActionsContext } from "./context";
import { ProductFormValues } from "./types";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { schema } from "./constants";
import pickBy from "lodash/pickBy";
import React from "react";

export interface ProductFormProviderProps {
  createActionContext?: boolean;
  onAfterAddProduct?: (product: Product) => void;
  children?: React.ReactNode;
  defaultFormValues?: Partial<ProductFormValues>;
}

export const ProductFormProvider = ({
  defaultFormValues,
  children,
  createActionContext = true,
  onAfterAddProduct,
}: ProductFormProviderProps) => {
  const normalizedDefaultValues: Partial<ProductFormValues> =
    React.useMemo(() => {
      return {
        ...{
          id: "",
          name: "",
          stockNumber: "",
          departmentId: "",
          categoryId: "",
          supplierId: "",
          supplierStockCode: "",
          locationId: "",
          taxGroupId: "",
          costPrice: "0",
          costPriceExlTax: "0",
          retailPrice: "0",
          tradePrice: "0",
          serialNumbersArr: false,
          serialNumbersSale: false,
          priceLookup: "",
          weight: "0",
          UOM: Uom.KG,
          /* ui helpers */
          globalDisable: false,
          taxRatePercent: 0,
          tradeMarkupPercent: 0,
          tradeMarkupType: "",
          markupPercent: 0,
          tags: [],
          description: "",
          selectedOptions: [],
        },
        ...pickBy(defaultFormValues),
      };
    }, []);

  const methods = useForm<ProductFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: normalizedDefaultValues,
    resolver: yupResolver(schema),
  });

  /**
   * MUST register all fields including ui/helpers
   * or react hook form will spaz out its dirty state
   */
  methods.register("id");
  methods.register("taxRatePercent");
  methods.register("tradeMarkupPercent");
  methods.register("tradeMarkupType");
  methods.register("markupPercent");
  methods.register("globalDisable");
  //methods.register("selectedOptions");

  const formState = methods.formState;
  const { isValid, isDirty, errors } = formState;

  const content = createActionContext ? (
    <ProductFormActionsContext.Provider
      value={{
        onAfterAddProduct,
      }}
    >
      {children}
    </ProductFormActionsContext.Provider>
  ) : (
    children
  );

  return <FormProvider {...methods}>{content}</FormProvider>;
};
